import React from 'react'
import { Outlet } from 'react-router-dom'

const VendorManagementOutlet = () => {
  return (
    <>
     <Outlet/>
    </>
  )
}

export default VendorManagementOutlet
